module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./OrderInfoView.js"));
	}, "AfterSaleDetailOrderInfoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleDetailOrderInfoView!./src/pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/OrderInfo/OrderInfoView.js
// module id = 1979
// module chunks = 367